import { Box, Button, Typography } from "@material-ui/core";
import { useState } from "react";
import NotihngStakedImg from "../../assets/images/nothing-staked.svg";
import BuyGainModel from "../Modals/BuyGainModel";
import useStyles from "../Styles/ShowProjectStyles";

export default function NotStaked({handleStakeClick}: {handleStakeClick:(value: boolean) => void}) {
  const [openBuy, setOpenBuy] = useState<boolean>(false);
  const classes = useStyles();

  return (
    <Box
      my={3}
      display="flex"
      justifyContent={"center"}
      alignItems="center"
      flexDirection={"column"}
      textAlign="center"
    >
      <img src={NotihngStakedImg} alt="Empty investments" style={{maxWidth:"90%"}} />
      <Typography className={classes.emptyTitle}>No GAINS staked</Typography>
      <Typography variant="body1" style={{ maxWidth: 365 }}>
      You haven’t staked any $GAINS tokens yet. Stake some tokens in order to invest in projects
      </Typography>
      <Box marginTop={"2rem"}>
        <Button
         variant="contained"
         color="secondary"
         onClick={()=> {handleStakeClick(true)}}
         className={classes.exploreBtn}
        >
          Stake GAINS
        </Button>
        <Button
          variant="contained"
          color="secondary"
          className={classes.buyGainsButton}
          onClick={() => {
            setOpenBuy(true);
          }}
        >
          Buy GAINS
        </Button>
      </Box>
      {openBuy && <BuyGainModel open={openBuy} setOpen={setOpenBuy} />}
    </Box>
  );
}
